import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AudienciaProgramadaProps, CancelarFechaAudienciaParams, defaultSolicitarFechaAudienciaResponse, SolicitarFechaAudienciaParams, SolicitarFechaAudienciaResponse } from '../../interfaces/audiencias/AgendaInterface';

export const SolicitarFechaAudiencia = ( params: SolicitarFechaAudienciaParams ) => {

    return new Promise<SolicitarFechaAudienciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Agenda/SolicitarFechaAudiencia/', params, token)
            .then( ({ data } : { data : SolicitarFechaAudienciaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultSolicitarFechaAudienciaResponse });
            });

        }

    });

}

export const BuscarAudienciaProgramada = ( id: number ) => {

    return new Promise<AudienciaProgramadaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Agenda/ObtenerAudienciasProgramadas/${id}`, token)
            .then( ({ data } : { data : AudienciaProgramadaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const CancelarFechaAudiencia = ( params: CancelarFechaAudienciaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Agenda/CancelarFechaAudiencia/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
